/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2021-27-09 00:00:00
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Field } from 'redux-form';
import { FormLayout, SkeletonBodyText } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import { RenderToggleSwitch } from 'src/components/views/common/forms/render-toggle-switch';
import { RenderTextField } from 'src/components/views/common/forms/render-textfield';
import { isRequired, hasTag, isExceedLength } from 'src/helpers/form-validation-helper';

const isRequiredValue = isRequired();

type Props = {
  enableSearchProducts: boolean,
  loading: boolean
};

type ComposedProps = Props & WithI18nProps;

class InCollectionSearch extends Component<ComposedProps> {
  exceedLength50Character = isExceedLength(
    50,
    this.props.i18n.translate('AdminHTML.Helpers.FormValidationHelper.invalid_Value_Length', {
      nt_number: 50
    })
  );
  render() {
    const { i18n, enableCollectionSearch, loading } = this.props;
    return loading ? (
      <FormLayout>
        <SkeletonBodyText lines={1} />
      </FormLayout>
    ) : (
      <FormLayout>
        <p>{i18n.translate('AdminHTML.SearchSettings.InCollectionSearch.description')}</p>
        <Field
          name="inCollectionSearch.enableCollectionSearch"
          component={RenderToggleSwitch}
          label={i18n.translate('AdminHTML.SearchSettings.InCollectionSearch.field_Active_Label')}
        />
        {enableCollectionSearch && (
          <div className="groupFields">
            <Field
              name="inCollectionSearch.collectionSearchLabel"
              component={RenderTextField}
              label={i18n.translate('AdminHTML.SearchSettings.InCollectionSearch.field_Label')}
              validate={[isRequiredValue, hasTag, this.exceedLength50Character]}
            />
          </div>
        )}
      </FormLayout>
    );
  }
}
export default withI18n()(InCollectionSearch);
